import { render, staticRenderFns } from "./LearningRequestTableItem.vue?vue&type=template&id=474e3e05&"
import script from "./LearningRequestTableItem.vue?vue&type=script&lang=ts&"
export * from "./LearningRequestTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports